import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { deepExtract } from 'helpers/deep';
export var Venue = function Venue() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Venue);

  _defineProperty(this, "type", 'venue');

  Object.assign(this, {
    activities: data.activities,
    alias: data.alias,
    description: data.description,
    id: data.venue_id || data.id,
    images: {
      small: Venue.getImage(data, '1x'),
      smallVertical: Venue.getImage(data, 'v1x')
    },
    location: data.location || {
      lat: data.lat,
      lon: data.lon
    },
    locationName: deepExtract('location.name', data) || data.location_name || data.neighborhood,
    name: data.name || data.venue_name,
    rating: data.display_rating_average,
    ratingCount: data.display_rating_total,
    subtitle: data.subtitle
  });
};

_defineProperty(Venue, "getImage", function (data, type) {
  var defaultImage = deepExtract('images.default', data);
  return deepExtract("images.mobile.".concat(type), data, defaultImage);
});